import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import { addEvent, removeEvent } from "../lib/eventHandler";

export interface ExitIntentTriggerParam {
    dangerZone: number;
}

export class ExitIntentTrigger implements Trigger {
    params: ExitIntentTriggerParam;

    constructor(params: ExitIntentTriggerParam) {
        this.params = params;
    }

    init = (action: Action) => {
        var fn = (event: any) => {
            if (event.clientY <= dangerZone || event["pageY"] <= dangerZone) {
                action.execute();
            }
        };

        var dangerZone = this.params.dangerZone;
        let box = document.querySelector("body");
        addEvent(box, "mousemove", fn);
    };
}
